import { DossierExportButton } from "./DossierExportButton";
import { Dossier } from "types/Dossier";
import { Badge } from "@mui/material";

export interface DossierExportsColumnProps {
    dossier: Dossier;
}

export function DossierExportsColumn(props: DossierExportsColumnProps) {
    const hasExportsAvailable = props.dossier.exportCount > 0;

    return (
        <>
            <Badge
                badgeContent={
                    hasExportsAvailable ? props.dossier.exportCount : null
                }
                color="secondary"
                overlap="circular"
            >
                <DossierExportButton
                    dossierId={props.dossier.id}
                    enabled={hasExportsAvailable}
                />
            </Badge>
        </>
    );
}
